import { useState } from "react";
import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";
import { StatCard } from "./resellerUi";

// Click = copia il codice negli appunti.
const ResellerCode = ({ resCode }) => {
  const [copied, setCopied] = useState(false);
  const hasCode = resCode !== undefined && resCode !== null && resCode !== "";

  function handleCopy() {
    if (!hasCode) return;
    navigator.clipboard?.writeText(String(resCode)).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    }).catch(() => {});
  }

  return (
    <StatCard
      icon={BadgeOutlinedIcon}
      label="Reseller code"
      value={hasCode ? resCode : "—"}
      hint={copied ? "Copied to clipboard" : hasCode ? "Click to copy" : undefined}
      onClick={hasCode ? handleCopy : undefined}
      chevron={false}
    />
  );
};

export default ResellerCode;
